/** The admin shows money as a grouped integer followed by the currency. */
export const formatAmountInFcfa = (amount?: number | null) => {
  return `${Number(amount ?? 0).toLocaleString("en-US")} FCFA`;
};
